export default __webpack_public_path__ + "static/media/three-dots-vertical.a0e2c514.svg";